import { memo } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { STATISTICS_THEME as T } from './statisticsOverlayConstants';

export default memo(function StatisticsSpectrogram({ title, data, leftInset = 0, rightInset = 0, loading }) {
  return (
    <Box sx={{ height: 56, pt: 1, boxSizing: 'border-box', flexShrink: 0 }}>
      <Typography sx={{ color: T.textHint, fontSize: 10, textTransform: 'uppercase', letterSpacing: 0.8, mb: 0.5 }}>{title}</Typography>
      <Box
        role="img"
        aria-label={`${title} over time`}
        sx={{
          ml: `${leftInset}px`,
          mr: `${rightInset}px`,
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: 24,
          border: `1px solid ${T.border}`,
          borderRadius: 0.5,
          overflow: 'hidden'
        }}>
        {loading ? (
          <CircularProgress size={20} thickness={5} sx={{ color: T.actualSpeed }} aria-label="Loading spectrogram" />
        ) : !data.length ? (
          <Typography sx={{ color: T.textMuted, fontSize: 11 }}>Unavailable</Typography>
        ) : (
          data.map((section) => (
            <Box
              key={section.key}
              title={section.tooltip}
              sx={{
                position: 'absolute',
                left: `${section.left * 100}%`,
                width: `${(section.right - section.left) * 100}%`,
                height: '100%',
                px: 0.5,
                boxSizing: 'border-box',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                color: T.textPrimary,
                fontSize: 10,
                lineHeight: '22px',
                backgroundColor: section.color
              }}>
              {section.value}
            </Box>
          ))
        )}
      </Box>
    </Box>
  );
});
